import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { genElTextDropdown } from "../../../../components/utils/EditorDialogElementGenerator";
import { Dropdown } from "primereact/dropdown";

const RemainingCustomerPackageFilter = (props) => {
  const { setFilterValue, filterValue, error, loading, BCList } = props;

  const [filter, setFilter] = useState({
    search: "",
    bc_id: 0,
  });

  return (
    <div className="w-full p-2 col-center-start gap-4 elevated-card-tight-vertical !rounded-lg !shadow-md border border-gray-300">
      <div className="flex justify-between items-center w-full">
        {/* Label */}
        <label className="flex items-center gap-2 text-lg font-semibold">
          <i className="pi pi-filter bg-gradient-to-br bg-clip-text text-transparent from-green-400 to-emerald-500" />
          Packages Filter
        </label>
      </div>
      <div className="col-center-start gap-2 w-full">
        <label className="row-start-center text-sm text-black font-medium">
          <i className="pi pi-users bg-gradient-to-br bg-clip-text text-transparent from-green-400 to-emerald-500 mr-2" />
          Filter By BC
        </label>
        <Dropdown
          value={filter.bc_id}
          onChange={(e) => setFilter({ ...filter, bc_id: e.value })}
          options={BCList}
          optionLabel="label"
          placeholder="Select BC"
          className="w-full text-slate-800 font-medium text-sm"
        />
      </div>
      <div className="col-center-start gap-2 w-full">
        <label className="row-start-center text-sm text-black font-medium">
          <i className="pi pi-search bg-gradient-to-br bg-clip-text text-transparent from-green-400 to-emerald-500 mr-2" />
          Filter By Package
        </label>
        <InputText
          value={filter.search}
          onChange={(e) => {
            const val = e.target.value;
            setFilter({ ...filter, search: val });
          }}
          placeholder="Search Package name..."
          disabled={loading}
          className="w-full text-slate-800 font-medium text-sm"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setFilterValue({
                ...filterValue,
                search: filter.search,
                bc_id: filter.bc_id,
              });
            }
          }}
        />
      </div>

      <div className="flex flex-col sm:flex-row justify-end items-center gap-2 w-full">
        <Button
          icon="pi pi-refresh"
          label="Load Report"
          loading={loading}
          className="w-full sm:w-auto whitespace-nowrap overflow-visible row-center-center sm:max-h-[3rem] rounded-md bg-gradient-to-br from-green-400 to-emerald-500 text-white font-semibold shadow-md hover:shadow-lg border-none"
          onClick={() => {
            setFilterValue({
              ...filterValue,
              search: filter.search,
              bc_id: filter.bc_id,
            });
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(RemainingCustomerPackageFilter);
